import { type HTMLAttributes, useState } from 'react';
import styled from 'styled-components';
import { useGiveInvocationFeedbackMutation } from 'autogen/swagger/all/hooks';
import FlexRow from 'components/Layout/components/Flex/components/FlexRow';
import FeedbackButton from './FeedbackButton';

type InSessionFeedbackProps = HTMLAttributes<HTMLDivElement> & {
    invocationId: string;
};

const Wrapper = styled(FlexRow)``;

const InSessionFeedback = (props: InSessionFeedbackProps) => {
    const { invocationId, className } = props;
    const { mutateAsync: giveFeedback } = useGiveInvocationFeedbackMutation();
    const [pressedType, setPressedType] = useState<null | 'upvote' | 'downvote'>(null);

    // When feedback is given, fade out after animation
    const handleGiveFeedback = (type: 'upvote' | 'downvote') => {
        if (!type) return;
        if (pressedType) return;

        giveFeedback({
            params: {
                invocationId: invocationId,
                feedback: type
            }
        });

        setPressedType(type);
    };

    return (
        <Wrapper gap="0px" style={{ pointerEvents: pressedType ? 'none' : 'auto' }} className={className}>
            <FeedbackButton
                feedbackType="upvote"
                feedbackGiven={pressedType === 'upvote'}
                fadingOut={!!pressedType && pressedType !== 'upvote'}
                onGiveFeedback={() => handleGiveFeedback('upvote')}
            />
            <FeedbackButton
                feedbackType="downvote"
                feedbackGiven={pressedType === 'downvote'}
                fadingOut={!!pressedType && pressedType !== 'downvote'}
                onGiveFeedback={() => handleGiveFeedback('downvote')}
            />
        </Wrapper>
    );
};

export default InSessionFeedback;
